// // src/pages/Dashboard.js
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Box, Button,Grid, Typography } from "@mui/material";
// import { logger } from "../utils/logger";
// import { logout } from "../redux/authSlice";
// import Sidebar from "../components/Sidebar";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import DonorManagement from "./DonorManagement";
// import DonationManagement from "./DonationManagment";
// import ImportDataPage from "./ImportData";
// import UserManagement from "../components/UserManagement";
// import Report from "./Report";
// import ResetPrasadPage from "./ResetPrasadPage";
// import UserList from "./UserList";
// import ManageOptions from "./ManageOptions";
// import UserLogDashboard from "./UserLogsManagement";
// import PayPurposePage from "./PayPurposePage";
// import ConfirmationDialog from "../components/ConfirmationDialog";
// import { usePageLogger } from "../hooks/usePageLogger";
// import DonorPieChart from "../components/Dashboard/DashboardCharts/DonorPieChart";
//  import DonorDashboardTable from "../components/Dashboard/DashboardTables/DonorDashboardTable";
//  import StatusTable from "../components/Dashboard/DashboardTables/StatusTable";
//  import StatusPie from "../components/Dashboard/DashboardCharts/StatusPie";

// import PayModeTable from "../components/Dashboard/DashboardTables/PayModeTable";
// import PayPurposeTable from "../components/Dashboard/DashboardTables/PayPurposeTable";
// import UtsavamTable from "../components/Dashboard/DashboardTables/UtsavamTable";
// import UtsavamDonutChart from "../components/Dashboard/DashboardCharts/UtsavamDonutChart";
// import PayModeChart from "../components/Dashboard/DashboardCharts/PayModeChart";
// import PayPurPosechart from "../components/Dashboard/DashboardCharts/PayPurPosechart";

// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";

// const Dashboard = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user, isAuthenticated } = useSelector((state) => state.auth);
// const [filterData, setFilterData] = useState(null);
//   const [selectedMenu, setSelectedMenu] = useState("dashboard");
//   const [openUserPopup, setOpenUserPopup] = useState(false);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false); 
//   const [activeAnalyticsTab, setActiveAnalyticsTab] = useState("salutation");
// // new state
//   usePageLogger("Dashboard Page", {
//     username: user?.username,
//     role: user?.role,
//   });

//   // const handleMenuSelect = useCallback((menu) => {
//   //   setSelectedMenu(menu);
//   // }, []);

//   const handleMenuSelect = useCallback((menu, data = null) => {
//   setSelectedMenu(menu);
//   setFilterData(data); // store filter info if provided
// }, []);

//   const confirmLogout = useCallback(() => {
//     setLogoutDialogOpen(false);

//     logger.info("Logout confirmed", {
//       username: user?.username,
//       role: user?.role,
//     });

//     try {
//       dispatch(logout());
//       logger.info("User logged out successfully", {
//         username: user?.username,
//         role: user?.role,
//       });
//       navigate("/login");
//     } catch (error) {
//       logger.error("Error during logout", {
//         error: error,
//         username: user?.username,
//         role: user?.role,
//       });
//     }
//   }, [dispatch, navigate, user]);

//   const handleLogout = useCallback(() => {
//     setLogoutDialogOpen(true);
//     logger.info("Logout confirmation dialog opened", {
//       username: user?.username,
//       role: user?.role,
//     });
//   }, [user]);

//   const handleCancelLogout = useCallback(() => {
//     setLogoutDialogOpen(false);
//     logger.info("Logout confirmation dialog closed (cancelled)", {
//       username: user?.username,
//       role: user?.role,
//     });
//   }, [user]);

//   const handleAddUser = useCallback(() => {
//     setOpenUserPopup(true);
//     logger.info("Add User modal opened", {
//       username: user?.username,
//       role: user?.role,
//     });
//   }, []);

//   const handleCloseUserPopup = useCallback(() => {
//     setOpenUserPopup(false);
//     logger.info("Add User modal closed", {
//       username: user?.username,
//       role: user?.role,
//     });
//   }, [user]);

//   useEffect(() => {
//     if (location.state?.selectedMenu) {
//       setSelectedMenu(location.state.selectedMenu);
//       logger.info("Selected menu restored from location state", {
//         menu: location.state.selectedMenu,
//         username: user?.username,
//         role: user?.role,
//       });
//     } else {
//       setSelectedMenu("dashboard");
//       logger.info("Default menu set to dashboard", {
//         username: user?.username,
//         role: user?.role,
//       });
//     }
//   }, [location.state, user]);

//   useEffect(() => {
//     if (!isAuthenticated) {
//       logger.info("User not authenticated, redirecting to login", {
//         username: user?.username,
//         role: user?.role,
//       });
//       navigate("/login");
//     }
//   }, [isAuthenticated, navigate, user]);

//   const renderContent = useMemo(() => {
//     switch (selectedMenu) {
//     case "dashboard": {
//   let dashboardItems = [];

//   if (activeAnalyticsTab === "salutation") {
//     dashboardItems = [
//       { component: <DonorPieChart />, title: "Salutation Chart" },
//       { component: <DonorDashboardTable />, title: "Salutation Table" },
//     ];
//   } 
//   else if (activeAnalyticsTab === "paypurpose") {
//     dashboardItems = [
//       { component: <PayPurPosechart />, title: "Pay Purpose Chart" },
//       { component: <PayPurposeTable />, title: "Pay Purpose Table" },
//     ];
//   } 
//   else if (activeAnalyticsTab === "paymode") {
//     dashboardItems = [
//       { component: <PayModeChart />, title: "Pay Mode Chart" },
//       { component: <PayModeTable />, title: "Pay Mode Table" },
//     ];
//   } 
//   else if (activeAnalyticsTab === "utsavam") {
//     dashboardItems = [
//       { component: <UtsavamDonutChart />, title: "Utsavam Chart" },
//       { component: <UtsavamTable/>, title: "Utsavam Table" },
//     ];
//   } 
//   else if (activeAnalyticsTab === "status") {
//     dashboardItems = [
//       { component: <StatusPie />, title: "Status Chart" },
//       { component: <StatusTable />, title: "Status Table" },
//     ];
//   }

//   return (
//     <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 3 }}>
//       <Box
//         sx={{
//           width: "100%",
//           backgroundColor: "white",
//           borderRadius: "10px",
//           padding: "25px",
//           boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//         }}
//       >
//         <Grid container spacing={3}>
//           {dashboardItems.map((item, index) => (
//             <Grid item xs={12} md={6} key={index}>
//               <Box
//                 sx={{
//                   backgroundColor: "#fafafa",
//                   borderRadius: "8px",
//                   padding: 2,
//                   minHeight: 250,
//                 }}
//               >
//                 {item.title && (
//                   <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
//                     {item.title}
//                   </Typography>
//                 )}
//                 {item.component}
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     </Box>
//   );
// }

//       case "donors":
//         return <DonorManagement />;
//       case "donations":
//         return <DonationManagement filterData={filterData} />;
//       case "paypurpose-details": 
//         return <PayPurposePage onMenuSelect={handleMenuSelect} />;
//       case "reports":
//         return <Report />;
//       case "import":
//         return <ImportDataPage />;
//       case "reset-prasad":
//         return <ResetPrasadPage />;
//       case "user-list":
//         return <UserList />;
//       case "manage-options":
//         return <ManageOptions />;
//       case "user-logs":
//         return <UserLogDashboard />;
//       default:
//         return (
//           <Typography variant="h5">
//             Select a section to view details.
//           </Typography>
//         );
//     }
//   }, [selectedMenu, filterData, handleMenuSelect,activeAnalyticsTab]);

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>

//       <Header user={user} onLogout={handleLogout} />
//       <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>

//         <Sidebar onMenuSelect={handleMenuSelect} user={user} />
//         <Box
//           sx={{
//             flexGrow: 1,
//             padding: "24px",
//             backgroundColor: "#f5f5f5",
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           {/* Main content area */}
         
//           {/* Add User button for superadmin/admin on dashboard */}
//           {selectedMenu === "dashboard" &&
//             (user?.role === "superadmin" || user?.role === "admin") && (
// //              
//   <Box sx={{ width: "100%", mb: 2 }}>
//   <Tabs
//     value={activeAnalyticsTab}
//     onChange={(e, value) => setActiveAnalyticsTab(value)}
//     textColor="primary"
//     indicatorColor="primary"
//   >
//     <Tab label="Salutation" value="salutation" />
//     <Tab label="Pay Purpose" value="paypurpose" />
//     <Tab label="Pay Mode" value="paymode" />
//     <Tab label="Utsavam" value="utsavam" />
//     <Tab label="Status" value="status" />
//   </Tabs>
// </Box>



//             )}
//              {renderContent}
//         </Box>

//         {openUserPopup && (
//           <UserManagement open={openUserPopup} onClose={handleCloseUserPopup} />
//         )}
//       </Box>
//       <Footer />
//       <ConfirmationDialog
//         open={logoutDialogOpen}
//         title="Confirm Logout"
//         message="Are you sure you want to logout?"
//         onConfirm={confirmLogout}
//         onCancel={handleCancelLogout}
//       />
//     </Box>
//   );
// };

// export default Dashboard;
// src/pages/Dashboard.js
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { logger } from "../utils/logger";
import { logout } from "../redux/authSlice";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import DonorManagement from "./DonorManagement";
import DonationManagement from "./DonationManagment";
import ImportDataPage from "./ImportData";
import UserManagement from "../components/UserManagement";
import Report from "./Report";
import ResetPrasadPage from "./ResetPrasadPage";
import UserList from "./UserList";
import ManageOptions from "./ManageOptions";
import UserLogDashboard from "./UserLogsManagement";
import DataExportPage from "./DataExportPage";       // ✅ fixes branch
import PayPurposePage from "./PayPurposePage";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { usePageLogger } from "../hooks/usePageLogger";
// ✅ dev branch: dashboard chart & table components
import DonorPieChart from "../components/Dashboard/DashboardCharts/DonorPieChart";
import DonorDashboardTable from "../components/Dashboard/DashboardTables/DonorDashboardTable";
import StatusTable from "../components/Dashboard/DashboardTables/StatusTable";
import StatusPie from "../components/Dashboard/DashboardCharts/StatusPie";
import PayModeTable from "../components/Dashboard/DashboardTables/PayModeTable";
import PayPurposeTable from "../components/Dashboard/DashboardTables/PayPurposeTable";
import UtsavamTable from "../components/Dashboard/DashboardTables/UtsavamTable";
import UtsavamDonutChart from "../components/Dashboard/DashboardCharts/UtsavamDonutChart";
import PayModeChart from "../components/Dashboard/DashboardCharts/PayModeChart";
import PayPurPosechart from "../components/Dashboard/DashboardCharts/PayPurPosechart";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const [filterData, setFilterData] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState("dashboard");
  const [openUserPopup, setOpenUserPopup] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [activeAnalyticsTab, setActiveAnalyticsTab] = useState("salutation"); // ✅ dev branch

  usePageLogger("Dashboard Page", {
    username: user?.username,
    role: user?.role,
  });

  const handleMenuSelect = useCallback((menu, data = null) => {
    setSelectedMenu(menu);
    setFilterData(data);
  }, []);

  const confirmLogout = useCallback(() => {
    setLogoutDialogOpen(false);

    logger.info("Logout confirmed", {
      page: "Dashboard", // ✅ fixes branch
      username: user?.username,
      role: user?.role,
    });

    try {
      dispatch(logout());
      logger.info("User logged out successfully", {
        page: "Dashboard", // ✅ fixes branch
        username: user?.username,
        role: user?.role,
      });
      navigate("/login");
    } catch (error) {
      logger.error("Error during logout", {
        page: "Dashboard", // ✅ fixes branch
        error: error,
        username: user?.username,
        role: user?.role,
      });
    }
  }, [dispatch, navigate, user]);

  const handleLogout = useCallback(() => {
    setLogoutDialogOpen(true);
    logger.info("Logout confirmation dialog opened", {
      page: "Dashboard", // ✅ fixes branch
      username: user?.username,
      role: user?.role,
    });
  }, [user]);

  const handleCancelLogout = useCallback(() => {
    setLogoutDialogOpen(false);
    logger.info("Logout confirmation dialog closed (cancelled)", {
      page: "Dashboard", // ✅ fixes branch
      username: user?.username,
      role: user?.role,
    });
  }, [user]);

  const handleAddUser = useCallback(() => {
    setOpenUserPopup(true);
    logger.info("Add User modal opened", {
      page: "Dashboard", // ✅ fixes branch
      username: user?.username,
      role: user?.role,
    });
  }, []);

  const handleCloseUserPopup = useCallback(() => {
    setOpenUserPopup(false);
    logger.info("Add User modal closed", {
      page: "Dashboard", // ✅ fixes branch
      username: user?.username,
      role: user?.role,
    });
  }, [user]);

  useEffect(() => {
    if (location.state?.selectedMenu) {
      setSelectedMenu(location.state.selectedMenu);
      logger.info("Selected menu restored from location state", {
        page: "Dashboard", // ✅ fixes branch
        menu: location.state.selectedMenu,
        username: user?.username,
        role: user?.role,
      });
    } else {
      setSelectedMenu("dashboard");
      logger.info("Default menu set to dashboard", {
        page: "Dashboard", // ✅ fixes branch
        username: user?.username,
        role: user?.role,
      });
    }
  }, [location.state, user]);

  useEffect(() => {
    if (!isAuthenticated) {
      logger.info("User not authenticated, redirecting to login", {
        page: "Dashboard", // ✅ fixes branch
        username: user?.username,
        role: user?.role,
      });
      navigate("/login");
    }
  }, [isAuthenticated, navigate, user]);

  const renderContent = useMemo(() => {
    switch (selectedMenu) {
      // ✅ dev branch: analytics dashboard with tabs
      case "dashboard": {
        let dashboardItems = [];

        if (activeAnalyticsTab === "salutation") {
          dashboardItems = [
            { component: <DonorPieChart />, title: "Salutation Chart" },
            { component: <DonorDashboardTable />, title: "Salutation Table" },
          ];
        } else if (activeAnalyticsTab === "paypurpose") {
          dashboardItems = [
            { component: <PayPurPosechart />, title: "Pay Purpose Chart" },
            { component: <PayPurposeTable />, title: "Pay Purpose Table" },
          ];
        } else if (activeAnalyticsTab === "paymode") {
          dashboardItems = [
            { component: <PayModeChart />, title: "Pay Mode Chart" },
            { component: <PayModeTable />, title: "Pay Mode Table" },
          ];
        } else if (activeAnalyticsTab === "utsavam") {
          dashboardItems = [
            { component: <UtsavamDonutChart />, title: "Utsavam Chart" },
            { component: <UtsavamTable />, title: "Utsavam Table" },
          ];
        } else if (activeAnalyticsTab === "status") {
          dashboardItems = [
            { component: <StatusPie />, title: "Status Chart" },
            { component: <StatusTable />, title: "Status Table" },
          ];
        }

        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              mt: 3,
            }}
          >
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "10px",
                padding: "25px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
            >
              <Grid container spacing={3}>
                {dashboardItems.map((item, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <Box
                      sx={{
                        backgroundColor: "#fafafa",
                        borderRadius: "8px",
                        padding: 2,
                        minHeight: 250,
                      }}
                    >
                      {item.title && (
                        <Typography
                          variant="h6"
                          fontWeight={600}
                          sx={{ mb: 1 }}
                        >
                          {item.title}
                        </Typography>
                      )}
                      {item.component}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        );
      }

      case "donors":
        return <DonorManagement />;
      case "donations":
        return <DonationManagement filterData={filterData} />;
      case "paypurpose-details":
        return <PayPurposePage onMenuSelect={handleMenuSelect} />;
      case "reports":
        return <Report />;
      case "import":
        return <ImportDataPage />;
      case "reset-prasad":
        return <ResetPrasadPage />;
      case "user-list":
        return <UserList />;
      case "manage-options":
        return <ManageOptions />;
      case "user-logs":
        return <UserLogDashboard />;
      case "data-export":               // ✅ fixes branch
        return <DataExportPage />;
      default:
        return (
          <Typography variant="h5">
            Select a section to view details.
          </Typography>
        );
    }
  }, [selectedMenu, filterData, handleMenuSelect, activeAnalyticsTab]);

  // ✅ fixes branch: admin1 + admin2 roles (dev had wrong "admin" string)
  const isAdminRole =
    user?.role === "superadmin" ||
    user?.role === "admin1" ||
    user?.role === "admin2";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header user={user} onLogout={handleLogout} />

      <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
        <Sidebar onMenuSelect={handleMenuSelect} user={user} />

        <Box
          sx={{
            flexGrow: 1,
            padding: "24px",
            backgroundColor: "#f5f5f5",
            opacity: 0.95,           // ✅ fixes branch
            display: "flex",
            flexDirection: "column",
          }}
        >
            {selectedMenu === "dashboard" && isAdminRole && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddUser}
              >
                Add User
              </Button>
            </Box>
          )}
          {/* ✅ dev branch: analytics tabs — shown on dashboard for admin roles */}
          {selectedMenu === "dashboard" && isAdminRole && (
            <Box sx={{ width: "100%", mb: 2 }}>
              <Tabs
                value={activeAnalyticsTab}
                onChange={(e, value) => setActiveAnalyticsTab(value)}
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab label="Salutation" value="salutation" />
                <Tab label="Pay Purpose" value="paypurpose" />
                <Tab label="Pay Mode" value="paymode" />
                <Tab label="Utsavam" value="utsavam" />
                <Tab label="Status" value="status" />
              </Tabs>
            </Box>
          )}

          {renderContent}

          {/* ✅ fixes branch: Add User button — restored from fixes (was missing in dev) */}
          {/* {selectedMenu === "dashboard" && isAdminRole && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddUser}
              >
                Add User
              </Button>
            </Box>
          )} */}
        </Box>

        {openUserPopup && (
          <UserManagement open={openUserPopup} onClose={handleCloseUserPopup} />
        )}
      </Box>

      <Footer />

      <ConfirmationDialog
        open={logoutDialogOpen}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        onConfirm={confirmLogout}
        onCancel={handleCancelLogout}
      />
    </Box>
  );
};

export default Dashboard;